import { MethodsEnum } from "../enums/Methods.ts";
import handleService from "./apiService.ts";

const listFeatures = async () => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/plano/funcionalidades",
  });
  return result;
};

const generateIntegrationToken = async () => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/setup/token-integracao"
  })
  return result;
}

// Gera (ou regenera, invalidando a anterior) a API key de longa duração usada
// pelo Delphi pra se autenticar sozinho via POST /integracao/v1/token. A chave
// em texto puro só vem nesta resposta — o backend nunca a expõe de novo depois.
const generateApiKey = async () => {
  const result = await handleService({
    method: MethodsEnum.POST,
    endpoint: "/setup/integracao-api-key",
  });
  return result;
};

const setupService = { listFeatures, generateIntegrationToken, generateApiKey };

export default setupService;